import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import { loginRequest } from './msalConfig'

const IS_MOCK = import.meta.env.VITE_MOCK_AUTH === 'true'

// Mock uživatel — role se řídí appsettings.Development.json MockAuth:Role
const MOCK_USER = {
  name: 'Jana Nováková',
  username: 'hr@firma.cz',
  roles: ['HR'],
}

export function useAuth() {
  const { instance, accounts } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  if (IS_MOCK) {
    return {
      isAuthenticated: true,
      account: { name: MOCK_USER.name, username: MOCK_USER.username },
      roles: MOCK_USER.roles,
      isHR: MOCK_USER.roles.includes('HR'),
      isAdmin: MOCK_USER.roles.includes('Admin'),
      isManager: MOCK_USER.roles.includes('Manager'),
      isEmployee: MOCK_USER.roles.includes('User'),
      login: () => {},
      logout: () => {},
      getAccessToken: async () => 'mock-token',
    }
  }

  const account = accounts[0] ?? null
  const login   = () => instance.loginPopup(loginRequest)
  const logout  = () => instance.logoutPopup({ account })

  const getAccessToken = async (): Promise<string> => {
    const response = await instance.acquireTokenSilent({
      ...loginRequest,
      account: account ?? undefined,
    })
    return response.accessToken
  }

  const roles: string[] = (account?.idTokenClaims as Record<string, unknown>)?.roles as string[] ?? []

  return {
    isAuthenticated,
    account,
    roles,
    isHR: roles.includes('HR'),
    isAdmin: roles.includes('Admin'),
    isManager: roles.includes('Manager'),
    isEmployee: roles.includes('User'),
    login,
    logout,
    getAccessToken,
  }
}
